import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// 頁面組件
import HomePage from './pages/HomePage';
import StudentHome from './pages/StudentHome';
import { TeacherHome } from './pages/TeacherHome';
import CorrectingRecords from './pages/ClassFeedback';
import { TeacherResult } from './pages/TeacherResult';
import UploadEssay from './pages/UploadEssay';
import Feedback from './pages/Feedback';
import OidcCallback from './pages/OidcCallback';
import StudentCallback from './pages/StudentCallback';
import TeacherCallback from './pages/TeacherCallback';
import SilentCallback from './pages/SilentCallback';
import { PrivacyPage } from './pages/PrivacyPage';
import ImageProcessingTest from './pages/ImageProcessingTest';
import ImageCropTest from './pages/ImageCropTest';
import BookPreview from './pages/BookPreview';
import BatchUpload from './pages/BatchUpload';

// 建立主題
const theme = createTheme({
  palette: {
    primary: {
      main: '#254D71',
      light: '#046CB7',
    },
    secondary: {
      main: '#2781E2',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      'system-ui',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'sans-serif',
    ].join(','),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/student-home" element={<StudentHome />} />
          <Route path="/teacher-home" element={<TeacherHome />} />
          <Route path="/upload-essay" element={<UploadEssay />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/oidc-callback" element={<OidcCallback />} />
          <Route path="/student-callback" element={<StudentCallback />} />
          <Route path="/teacher-callback" element={<TeacherCallback />} />
          <Route path="/teacher/correcting-records" element={<CorrectingRecords />} />
          <Route path="/teacher/correcting-records/result" element={<TeacherResult />} />
          <Route path="/silent-callback" element={<SilentCallback />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/image-test" element={<ImageProcessingTest />} />
          <Route path="/image-crop-test" element={<ImageCropTest />} />
          <Route path="/book-preview" element={<BookPreview />} />
          <Route path="/batch-upload" element={<BatchUpload />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
